var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-3"},[_c('label',[_vm._v("Start With")]),_c('div',{staticClass:"border"},[_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-sm-4 col-md-4"},[_c('router-link',{attrs:{"to":{
            name: 'AdminAddPointsSelectPrograms',
          }}},[_vm._v("Select A Program/Contest")])],1),_c('div',{staticClass:"col-sm-4 col-md-4"},[_c('router-link',{attrs:{"to":{
            name: 'AdminPointProgramsNewProgramContest',
          }}},[_vm._v("Add New Program/Contest")])],1),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-4 col-md-4"},[_c('a',{attrs:{"href":"/point-programs/list"}},[_vm._v("Manage Program/Contest")])])
}]

export { render, staticRenderFns }